/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, memo } from "react";
import Commune from "./components/Commune/Commune";
import Election from "./components/Election/Election";
import Housing from "./components/Housing/Housing";
import Politic from "./components/Politic/Politic";
import Population from "./components/Population/Population";

import Error from "./components/Error/Error";
import Loader from "./components/Loader/Loader";
import { useCommuneData } from "./hooks/useCommuneData";
import { useCandidateData } from "./hooks/useCandidateData";
import { useSearchParams } from "./hooks/useSearchParams";
import { useArticlesData } from "./hooks/useArticlesData";
import CandidatesContainer from "./components/Canditates/CandidatesContainer";
import Footer from "./components/Footer/Footer";

// import communeData from "../src/assets/55-commune.json";
import communesLookup from "../src/assets/commune-lookup.json";
import { getIdFromName } from "./utils/communesUtils";
import Newsticker from "./components/Newsticker/Newsticker";
import { Faq } from "./assets";
import Elected from "./components/Elected/Elected";
import { useResultsData } from "./hooks/useResultsData";
import Result from "./components/Result/Result";
import TooltipContent from "./components/Canditates/TooltipContent";

function App() {
  const langId = useSearchParams("lang");
  const communeId = useSearchParams("commune");

  const { data, loading, error } = useCandidateData(langId);
  const { communeData, communeDataLoading, communeDataError } =
    useCommuneData(communeId);

  const { resultsData, resultsLoading, resultsError } = useResultsData(
    communeId,
    "2023",
    "2017"
  );

  const { articlesData, articlesDataLoading, articlesDataError } =
    useArticlesData(langId);

  const [communeArticles, setCommuneArticles] = useState([]);
  const [width, setWindowWidth] = useState(0);
  const [currentCommune, setCurrentCommune] = useState("");
  const [tooltip, setTooltip] = useState({
    isVisible: true,
    details: null,
    position: { top: 0, left: 0 },
  });

  const handleShowTooltip = (event, details) => {
    const rect = event.target.getBoundingClientRect();
    setTooltip({
      isVisible: true,
      details,
      position: { top: rect.top, left: rect.left },
    });
  };

  const handleHideTooltip = () => {
    setTooltip({
      isVisible: false,
      details: null,
      position: { top: 0, left: 0 },
    });
  };

  const isDesktop = width > 750;

  const updateDimensions = () => {
    const width = window.innerWidth;
    setWindowWidth(width);
  };

  const communLangId =
    langId === "en" || langId === "pt" ? "fr" : langId === "fr" ? "fr" : "de";

  useEffect(() => {
    setTimeout(() => {
      window.wort.frameResize();
    }, 100);
    updateDimensions();
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  useEffect(() => {
    if (communeId === "5") {
      const berdorfArticle =
        "https://www.wort.lu/de/lokales/gemeindewahl-in-berdorf-wird-wegen-todesfall-verschoben-64622dfbde135b92362898d9?utm_source=election-module";

      // Perform the redirect
      window.location.href = berdorfArticle;
    }
    if (communeId && communesLookup[communLangId][communeId]) {
      setCurrentCommune(communesLookup[communLangId][communeId]);
    } else {
      setCurrentCommune(communesLookup[communLangId]["54"]);
    }
  }, [communeId]);

  useEffect(() => {
    if (articlesData && currentCommune) {
      setCommuneArticles(
        articlesData.filter((item) => item.commune === currentCommune)
      );
    }
  }, [articlesData, currentCommune]);

  if (loading || communeDataLoading || articlesDataLoading || resultsLoading)
    return <Loader />;

  if (
    !data ||
    !communeData ||
    error ||
    communeDataError ||
    articlesDataError ||
    resultsError
  )
    return <Error error={error} />;

  const onClickScrollHandler = () => {
    const element = document.getElementById("population-section");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const onGoToSearchHandler = () => {
    // navigate Parent To Url
    const urls = {
      fr: "luxembourg/module-de-la-campagne-electorale-2023/1350987.html",
      de: "luxemburg/module-wahlkampagne/1362016.html",
      en: "en/luxembourg/election-campaign-module-6426b10ade135b923669a86a",
      pt: "luxemburgo/m-dulo-eleitoral/1354014.html",
    };

    const hosts = {
      fr: "https://www.virgule.lu",
      de: "https://www.wort.lu",
      en: "https://www.luxtimes.lu",
      pt: "https://www.contacto.lu",
    };

    const message = {
      type: "navigate",
      url: urls[langId],
    };

    window.parent.postMessage(message, hosts[langId]);
  };

  const filteredCommunes = (commune) => {
    const filteredData = data.data.filter((item) => {
      return item.commune === commune;
    });
    return filteredData;
  };

  const goToFaq = () => {
    if (langId === "de") {
      window.open(
        "https://www.wort.lu/de/lokales/die-wichtigsten-fragen-zu-den-gemeindewahlen-am-11-juni-63bd7111de135b923672b9fc",
        "_blank"
      );
    } else {
      window.open(
        `https://data-assets.wort.lu/elections/faq/index.html?lang=${langId}`,
        "_blank"
      );
    }
  };
  const getSiteSource = () => {
    if (process.env.NODE_ENV === "development") {
      return "/?";
    } else {
      return `${window.location.origin}/elections/campaign-details/index.html?`;
    }
  };

  const onCommuneSearch = (query) => {
    if (query && query !== "reset") {
      const communeId = getIdFromName(communesLookup[communLangId], query);
      window.open(
        `${getSiteSource()}lang=${langId}&commune=${communeId}`,
        "_self"
      );
    } else if (query && query === "reset") {
    }
    window.wort.frameResize();
  };

  const evolutiveData = filteredCommunes(
    communesLookup[communLangId][communeId]
  )[0];

  const hasCommuneArticles = communeArticles.length > 0;
  const mixedSystemCommuneIds = [2, 8, 28, 65, 71];
  const specialCaseIds = [113, 112];
  const hasElectionSystemChanged = mixedSystemCommuneIds.includes(
    parseInt(communeId)
  );
  const isSpeacialCase = specialCaseIds.includes(parseInt(communeId));

  const isBigCommune =
    resultsData["2023"].results.resultats?.listes?.length > 0;

  let metaData = filteredCommunes(communesLookup[communLangId][communeId]);

  const hasCoalition = communeData.coalitionsGender;

  return (
    <div className="mx-4 wort-medium:w-[1200px] wort-medium:m-auto">
      {!isSpeacialCase && (
        <Commune
          data={evolutiveData}
          communeData={communeData}
          scrollHandler={onClickScrollHandler}
          langId={langId}
          communeId={communeId}
          hasElectionSystemChanged={hasElectionSystemChanged}
          goToSearchHandler={onGoToSearchHandler}
        />
      )}

      {isBigCommune && (
        <>
          <Result
            data={resultsData}
            langId={langId}
            isDesktop={isDesktop}
            currentElected={communeData.elected}
            meta={metaData}
          />
          {hasCoalition && (
            <Politic
              resultsData={resultsData}
              data={communeData}
              commune={currentCommune}
              langId={langId}
              isDesktop={isDesktop}
              communeId={communeId}
              hasElectionSystemChanged={hasElectionSystemChanged}
            />
          )}
        </>
      )}

      <Elected
        data={resultsData}
        langId={langId}
        isDesktop={isDesktop}
        currentElected={communeData.elected}
        meta={metaData}
        handleShowTooltip={handleShowTooltip}
        handleHideTooltip={handleHideTooltip}
        communeId={communeId}
        isSpeacialCase={isSpeacialCase}
      />

      <div className="wort-medium:mt-12">
        {metaData.map((item, index) => (
          <CandidatesContainer
            key={index}
            data={item}
            index={index}
            langId={langId}
            isDesktop={isDesktop}
            handleShowTooltip={handleShowTooltip}
            handleHideTooltip={handleHideTooltip}
          />
        ))}
      </div>
      {!isSpeacialCase && evolutiveData && (
        <>
          <Election
            data={communeData}
            evolutiveData={evolutiveData}
            langId={langId}
          />
          <Population
            data={communeData}
            langId={langId}
            commune={currentCommune}
            isDesktop={isDesktop}
          />
        </>
      )}
      {communeData.propertyPrices && (
        <Housing data={communeData} langId={langId} />
      )}
      {hasCommuneArticles && (
        <Newsticker
          langId={langId}
          data={communeArticles}
          commune={currentCommune}
        />
      )}
      <Footer
        data={data.lookup.communes}
        communeQueryHandler={onCommuneSearch}
        isDesktop={isDesktop}
        langId={langId}
      />
      <button
        className="fixed bg-primary text-white font-bold py-4 px-6 rounded-0 z-50 w-[60px] h-[60px] wort-medium:w-[96px] wort-medium:h-[88px]"
        onClick={goToFaq}
        style={{ top: "280px", right: "0px" }}
      >
        <div className="absolute inset-0 flex flex-col items-center justify-center w-full h-full">
          <Faq className="w-[32px] h-[31.24px] wort-medium:w-[44px] wort-medium:h-[39.87px]" />
          <span className="text-xs wort-medium:text-base">FAQ</span>
        </div>
      </button>
      {tooltip.isVisible && (
        <TooltipContent
          details={tooltip.details}
          langId={langId}
          style={{
            position: "fixed",
            top: tooltip.position.top - 390, // 375
            left: tooltip.position.left - 335, // 375
          }}
        />
      )}
    </div>
  );
}

export default App;
